import { Injectable } from '@angular/core';
import { ResourceService } from '../resource/resource.service';
import { HttpService } from '../http-service/http.service';
import { ResourceModel } from '../../../../core/models/resources/resource.model';
import { ServiceModule } from '../../../service.module';

@Injectable({ providedIn: ServiceModule })
export class ContentItemService extends ResourceService<ResourceModel> {
    getResourceUrl(): string {
        return 'content';
    }

    constructor(protected override httpService: HttpService<ResourceModel>) {
        super(httpService);
    }
}
